/* eslint-disable */
export default {
  recentActivities: '최근 활동',
  text: '문자',
  fax: '팩스',
  voicemail: '음성 사서함',
  call: '전화',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
